<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      :title="$t('text.recharge')"
      :visible="isShowRechargeDialog"
      width="30%"
      :close-on-click-modal="false"
      @close="handleDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="170px">
        <el-form-item :label="$t('text.rechargeAmount')" prop="amount">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            :placeholder="$t('message.inputRechargeAmount')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.disbursementAccount')" prop="paymentAccount">
          <el-input
            size="small"
            type="text"
            v-model="form.paymentAccount"
            :placeholder="$t('message.inputYourWalletAddress')"
            show-word-limit
            maxlength="42"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.collectionAddress')" prop="collectAccount">
          <el-input
            size="small"
            type="text"
            v-model="form.collectAccount"
            :placeholder="$t('message.inputPlatformWalletAddress')"
            show-word-limit
            maxlength="42"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            :placeholder="$t('message.inputRechargeWithdrawRemark')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowRechargeDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        type: "00",
        amount: "",
        paymentAccount: "",
        collectAccount: "",
        remark: ""
      },
      rules: {
        amount: [
          { required: true, message: this.$t('message.inputRechargeAmount'), trigger: "blur" }
        ],
        paymentAccount: [
          { required: true, message: this.$t('message.inputYourWalletAddress'), trigger: "blur" },
          { max: 42, message: this.$t('message.inputYourWalletAddress'), trigger: "blur" }
        ],
        collectAccount: [
          { required: true, message: this.$t('message.inputPlatformWalletAddress'), trigger: "blur" },
          { max: 42, message: this.$t('message.inputPlatformWalletAddress'), trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        type: "00",
        amount: "",
        paymentAccount: "",
        collectAccount: "",
        remark: ""
      };
      this.$emit("update:isShowRechargeDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = {
            ...this.form
          };
          this.$axios
            .post("/depositWithdraw/addDepositWithdraw", params)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$emit("update:isShowRechargeDialog", false);
                this.$bus.$emit("refresh"); //通知刷新
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>
